import React from 'react'

function ManSocAcc() {
  return (
    <div></div>
  )
}

export default ManSocAcc